module.exports = __webpack_public_path__ + "static/media/es.63015e21.jpg";